/* Claris residential category — View All toggle + filter architecture.
   Note: function names use ASCII "claris" (the source spec contained
   Cyrillic look-alike characters that would break the identifiers). */

function clarisToggleAll(btn) {
  var gridId = btn.dataset.grid;
  var grid = document.getElementById(gridId);
  if (!grid) return;

  var extras = grid.querySelectorAll('.product-card.extra, .grid-group-label.extra');
  var expanded = btn.dataset.expanded === 'true';

  if (expanded) {
    extras.forEach(function (el) { el.classList.remove('visible'); });
    btn.textContent = btn.dataset.showLabel;
    btn.dataset.expanded = 'false';
  } else {
    extras.forEach(function (el) { el.classList.add('visible'); });
    btn.textContent = 'Show less ↑';
    btn.dataset.expanded = 'true';
  }
}

function clarisInitFilters(sectionId) {
  var filterBar = document.getElementById(sectionId + '-filters');
  var grid = document.getElementById(sectionId + '-grid');
  if (!filterBar || !grid) return;

  filterBar.style.display = 'flex'; // reveal the bar when JS activates it

  filterBar.addEventListener('click', function (e) {
    var pill = e.target.closest('.filter-pill');
    if (!pill) return;

    filterBar.querySelectorAll('.filter-pill').forEach(function (p) {
      p.classList.remove('active');
    });
    pill.classList.add('active');

    var filter = pill.dataset.filter;

    grid.querySelectorAll('.product-card').forEach(function (card) {
      if (filter === 'all') {
        card.removeAttribute('data-hidden');
        return;
      }
      if (filter === 'no-led') {
        var hasLed = card.dataset.led === 'true';
        if (hasLed) { card.dataset.hidden = 'true'; }
        else { card.removeAttribute('data-hidden'); }
        return;
      }
      // kebab-case filter -> camelCase data attribute
      var attr = filter.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
      var match = card.dataset[attr] === 'true';
      if (match) { card.removeAttribute('data-hidden'); }
      else { card.dataset.hidden = 'true'; }
    });
  });
}

window.clarisToggleAll = clarisToggleAll;
window.clarisInitFilters = clarisInitFilters;
